import styled from "styled-components";

export default styled.div`
  .staking-row {
    margin-top: 21px;
  }
  .StakingOverAlert {
    line-height: 1.5;
    text-transform: uppercase;
    font-size: 3rem;
  }
  .StakingOverAlertType:after {
    height: 245px;
    width: 245px;
    right: 8px;
    top: -47px;
  }
  @media screen and (max-width: 769px) {
    .size-small {
      display: none;
    }
  }
`;
